import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class TrackerDishes extends Vue {
  @Getter getCurrentOrder: any
  @Getter getCountry: any

  _money (val) {
    const price = parseFloat(val)
    return this.$currency.format(price, { code: this.getCountry.currency })
  }
}
